import { useEffect } from 'react';

const usePageInteractions = () => {
    useEffect(() => {
        // Smooth scroll for navigation anchors
        const handleSmoothScroll = (e) => {
            if (e.target.tagName === 'A' && e.target.getAttribute('href')?.startsWith('#')) {
                e.preventDefault();
                const target = document.querySelector(e.target.getAttribute('href'));
                if (target) {
                    target.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }
            }
        };

        // Demo button functionality
        const handleDemoButton = function() {
            this.textContent = 'Simulating...';
            this.style.background = 'linear-gradient(135deg, #7C3AED 0%, #048ABF 100%)';

            setTimeout(() => {
                this.textContent = 'View Results';
                this.style.background = 'linear-gradient(135deg, #10B981 0%, #059669 100%)';

                // Animate the chart
                const chartLine = document.querySelector('.chart-line');
                if (chartLine) {
                    chartLine.style.animation = 'none';
                    setTimeout(() => {
                        chartLine.style.animation = 'drawChart 2s ease-in-out';
                    }, 10);
                }

                setTimeout(() => {
                    this.textContent = 'Run Simulation';
                    this.style.background = 'var(--gradient-accent)';
                }, 3000);
            }, 2000);
        };

        // Number counter animation
        const animateValue = (element, start, end, duration, originalText) => {
            let startTimestamp = null;
            const step = (timestamp) => {
                if (!startTimestamp) startTimestamp = timestamp;
                const progress = Math.min((timestamp - startTimestamp) / duration, 1);
                const currentValue = Math.floor(progress * (end - start) + start);
                
                // Preserve the original format (% or x)
                if (originalText.includes('%')) {
                    element.textContent = currentValue + '%';
                } else if (originalText.includes('x')) {
                    element.textContent = currentValue + ' x';
                } else {
                    element.textContent = currentValue;
                }
                
                if (progress < 1) {
                    window.requestAnimationFrame(step);
                }
            };
            window.requestAnimationFrame(step);
        };

        // Counter animation observer
        const counterObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const target = entry.target;
                    const originalText = target.textContent;
                    const endValue = parseInt(originalText);
                    if (!isNaN(endValue)) {
                        animateValue(target, 0, endValue, 2000, originalText);
                        counterObserver.unobserve(target);
                    }
                }
            });
        }, { threshold: 0.5 });

        // Setup event listeners
        const setupListeners = () => {
            // Smooth scroll
            document.addEventListener('click', handleSmoothScroll);

            // Demo button
            const demoButton = document.querySelector('.demo-run-btn');
            if (demoButton) {
                demoButton.addEventListener('click', handleDemoButton);
            }

            // Counter animations
            document.querySelectorAll('.metric-value, .stat-number, .case-metric-value').forEach(el => {
                counterObserver.observe(el);
            });
        };

        // Setup with small delay to ensure DOM is ready
        setTimeout(setupListeners, 100);

        return () => {
            document.removeEventListener('click', handleSmoothScroll);
            const demoButton = document.querySelector('.demo-run-btn');
            if (demoButton) {
                demoButton.removeEventListener('click', handleDemoButton);
            }
        };
    }, []);
};

export default usePageInteractions;